import { addChapterAction,
  deleteChapterAction,
  saveChapterAction,
  cancelChapterAction,
  retrieveChaptersAction,
  showChaptersFormAction,
  removeChapterAction } from './actions';

const initialState = {
  chapters: {},
  isLoading: false,
  isError: false,
  shouldShowChaptersForm: false,
  newChapter: null
};

const chaptersReducer = (state = initialState, action) => {
  switch (action.type) {
    case addChapterAction.toString(): {
      const { hoverTime } = action;
      const newChapter = { chapterTitle: '', chapterStartTimeSeconds: hoverTime ?? '' };
      return {
        ...state,
        newChapter
      };
    }

    case cancelChapterAction.toString(): {
      const { recordingId } = action;
      const existingChapters = state.chapters[recordingId] || [];
      const newChapters = existingChapters.filter((chapter) => chapter.chapterId);
      return {
        ...state,
        chapters: {
          ...state.chapters,
          [recordingId]: newChapters
        },
        shouldShowChaptersForm: false
      };
    }

    case removeChapterAction.toString(): {
      const { recordingId, index } = action;
      const existingChapters = state.chapters[recordingId] || [];
      existingChapters.splice(index, 1);
      return {
        ...state,
        chapters: {
          ...state.chapters,
          [recordingId]: [...existingChapters]
        }
      };
    }

    case showChaptersFormAction.toString(): {
      const { shouldShowChaptersForm } = action;
      return {
        ...state,
        shouldShowChaptersForm
      };
    }

    case retrieveChaptersAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    }

    case retrieveChaptersAction.complete.toString(): {
      const fetchedChapters = action.payload;
      const newChapters = {
        ...state.chapters,
        ...fetchedChapters
      };
      return {
        ...state,
        isLoading: false,
        chapters: newChapters
      };
    }

    case retrieveChaptersAction.failed.toString(): {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }

    case saveChapterAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    }

    case saveChapterAction.complete.toString(): {
      const newChapters = action.payload;
      return {
        ...state,
        isLoading: false,
        chapters: {
          ...state.chapters,
          ...newChapters
        },
        shouldShowChaptersForm: false
      };
    }

    case saveChapterAction.failed.toString(): {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }

    case deleteChapterAction.toString(): {
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    }

    case deleteChapterAction.complete.toString(): {
      const { deletedChapterId, recordingId } = action.payload;
      return {
        ...state,
        isLoading: false,
        chapters: {
          ...state.chapters,
          [recordingId]: state.chapters[recordingId].filter((chapter) => chapter.chapterId !== deletedChapterId)
        }
      };
    }

    case deleteChapterAction.failed.toString(): {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }

    default:
      return state;
  }
};

export default chaptersReducer;
